import { FormElementThemeColor, SelectOption } from '@tmh-website/ui/FormElements';

import * as Styled from './MultiselectEntry.styles';

interface MultiselectEntryProps extends SelectOption {
  themeColor: FormElementThemeColor;
  checked: boolean;
}

export const MultiselectEntry = ({ label, checked, disabled, themeColor }: MultiselectEntryProps) => {
  return (
    <Styled.Entry $isDisabled={!!disabled} $themeColor={themeColor}>
      <span>{label}</span>
      <Styled.Checkmark $isVisible={checked} $isDisabled={!!disabled} $themeColor={themeColor} />
    </Styled.Entry>
  );
};

export default MultiselectEntry;
